import { type MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { type BoxSettingsFormFields } from "@modules/box/boxSettingsFormikType"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useBoxSettingsActions = () => {
  const { boxApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: updateBoxSettings, isPending: isUpdating } = useMutation({
    mutationFn: async ({ boxId, box }: { boxId: string; box: BoxSettingsFormFields }) => {
      await boxApi.updateBoxSettings(boxId, {
        paymentMethodPreferences: box.paymentMethodPreferences,
        slotGeneratorInWeeks: box.slotGeneratorInWeeks,
        showSessionAttendees: box.showSessionAttendees,
        payoutFrequency: box.payoutFrequency,
      })
    },
    onSuccess: async (_, { boxId }) => {
      await queryClient.invalidateQueries({
        queryKey: ["box", boxId],
      })
    },
  })

  const { mutateAsync: updateBoxWaiver, isPending: isUpdatingWaiver } = useMutation({
    mutationFn: async ({ boxId, waiver }: { boxId: string; waiver: MediaItemFormType | null }) => {
      await boxApi.updateBoxWaiver(boxId, waiver?.key ? { key: waiver.key, filename: waiver.filename ?? "" } : null)
    },
    onSuccess: async (_, { boxId }) => {
      await queryClient.invalidateQueries({
        queryKey: ["box", boxId],
      })
    },
  })

  return {
    updateBoxSettings,
    isUpdating,
    updateBoxWaiver,
    isUpdatingWaiver,
  }
}
